
import React, { Component } from "react";
import { Input, Box, HStack, Text, Button } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faRemoveFormat } from "@fortawesome/free-solid-svg-icons";


export default class MultiEntryKeyPairInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            entries: [],
            currentKey: "",
            currentValue: ""
        }


        this.createEntry = this.createEntry.bind(this);
        this.displayEntries = this.displayEntries.bind(this);
        this.onPropKeyChange = this.onPropKeyChange.bind(this);
        this.onPropValueChange = this.onPropValueChange.bind(this);
        this.editEntry = this.editEntry.bind(this);
        this.removeEntry = this.removeEntry.bind(this);
    }



    componentDidMount(){
        if (this.props.cardValue)
        {
            var entries = this.props.cardValue?.map((c) => {return {key: c[this.props.card.keyProp], value: c[this.props.card.valueProp]}});
            this.setState({entries: entries});
        }
    }

    createEntry(entryKey, entryValue) {
        var newEntry = {
            key: entryKey,
            value: entryValue
        }
        var currentEntries = this.state.entries
        currentEntries.push(newEntry)
        this.setState({
            entries: currentEntries,
            currentKey: "",
            currentValue: ""
        });

        var keyProp = this.props.card.keyProp;
        var valueProp = this.props.card.valueProp;
        var value = currentEntries.map((kv) => {
            let obj = {};
            obj[keyProp] = kv.key;
            obj[valueProp] = kv.value;
            return obj;
        });
        this.props.onValueChange(value);
    };





    displayEntries() {
        var entryList = [];
        var current = this.state.entries
        if (current.length !== 0) {
            this.state.entries.map((ent, index) => {
                entryList.push(
                    <HStack color="white" borderBottom={"1px solid white"}>
                        <Text m='0' w='40%'>{(ent.key) ? ent.key : " "}</Text>
                        <Text m='0' w='50%'>{ent.value}</Text>
                        <FontAwesomeIcon icon={faPen} onClick={()=>this.editEntry(index)}/>
                        <FontAwesomeIcon icon={faRemoveFormat} onClick={()=>this.removeEntry(index)}/>
                    </HStack>
                )
            })
            return entryList
        }
    }

    editEntry(i){
        this.setState({
            currentKey: this.state.entries[i].key,
            currentValue: this.state.entries[i].value
        })
        this.removeEntry(i)
    }

    removeEntry(index) {
        var tempEntries = this.state.entries.filter((_, i) => i !== index)
    
        this.setState({
          entries: tempEntries
        })
      }

    onPropKeyChange(e) {
        this.setState({
            currentKey: e.target.value
        })
    }

    onPropValueChange(e) {
        this.setState({
            currentValue: e.target.value
        })
    }

    render() {

        return (
            <Box>
                {this.displayEntries()}
                <HStack align={"flex-end"}>
                    <Box>
                        <Text margin='0' color='white' fontSize='12px'>{this.props.card.keyLabel}</Text>
                        <Input
                            autoFocus
                            backgroundColor={"white"}
                            value={this.state.currentKey}
                            onChange={this.onPropKeyChange}
                        />
                    </Box>
                    <Box>
                        <Text margin='0' color='white' fontSize='12px'>{this.props.card.valueLabel}</Text>
                        <Input
                            autoFocus
                            backgroundColor={"white"}
                            value={this.state.currentValue}
                            onChange={this.onPropValueChange}
                        />
                    </Box>
                    <Button
                        onClick={() => this.createEntry(this.state.currentKey, this.state.currentValue)}
                    >Add</Button>
                </HStack>
            </Box>
        )
    }
}







